async function endSession(): Promise<number> {
  try {
    const url = `https://ruuf-backend.online/logout`;
    const timeout = new Promise<Response>((_, reject) =>
      setTimeout(() => reject(new Error("Request timed out")), 10000),
    );

    const response = await Promise.race([
      fetch(url, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      }),
      timeout,
    ]);

    if (!(response instanceof Response)) {
      throw response;
    }

    if (response.status === 200) {
      console.log("Logged out and cookie deleted successfully");
      window.location.href = "/";
      return 0;
    } else {
        throw new Error("Error ending session");
    }
  } catch (error) {
    console.error("Error ending session:", error);
    return -1;
  }
}

export default endSession;
